import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=32d195de"
import script from "./CustomReports.vue?vue&type=script&lang=js"
export * from "./CustomReports.vue?vue&type=script&lang=js"
import style0 from "./CustomReports.vue?vue&type=style&index=0&id=32d195de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports